import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Calculator from "../pages/Calculator";
import NotFound from "../pages/NotFound";

const App = () => {

  return (
    <BrowserRouter>
      <div className="app">
        <Routes>
          <Route path="/" element={<Calculator/>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <ToastContainer />
      </div>
    </BrowserRouter>
  );
}

export default App;
